import axios from 'axios';

export default {
    contactRequest (contactData) {
        return axios
            .post('/api/auth/contact_signup', contactData)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    docRequest (contactData) {
        return axios
            .post('/api/auth/doc_request_signup', contactData)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    /*docRequest(data) {
      return axios
          .post("/api/candidate/doc_request", data)
          .then(response => {
            return response;
          })
          .catch(error => {
            return error.response;
          });
    },*/
    newUserAccount (contactData) {
        return axios
            .post('/api/candidates/user/add', contactData)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    updateUserAccount (data) {
        return axios
            .post('/api/account/update', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    newCandidate (contactData) {
        return axios
            .post('/api/candidates/add', contactData)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    simpleFormCandidate (contactData) {
        return axios
            .post('/api/candidates/simpleform', contactData)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    getContact (id) {
        return axios
            .get('/api/candidate/' + id)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    getNetcampusCandidateAttendant (candidate_id) {
        return axios
            .get('/api/candidate/attendant/' + candidate_id)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    deleteCandidate (data) {
        return axios
            .post('/api/candidate/delete', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    archiveCandidate (data) {
        return axios
            .post('/api/candidate/archive', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    resetPasswordCandidate (data) {
        return axios
            .post('/api/candidate/reset_password', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    updateCandidate (data) {
        return axios
            .post('/api/candidate/update', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    addCandidate (data) {
        return axios
            .post('/api/candidate/add', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    addShopCandidate (data) {
        return axios
            .post('/api/candidate/shop/add', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    saveChoices (data) {
        return axios
            .post('/api/candidate/application/choices', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    sendChangeRequest (data) {
        return axios
            .post('/api/candidate/application/choices_change_request', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    saveCurriculum (data) {
        return axios
            .post('/api/candidate/curriculum', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    searchHighSchools (params) {
        return axios
            .get('/api/candidate/high-schools/search', {
                params
            })
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    saveMotivation (data) {
        return axios
            .post('/api/candidate/motivation', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    fetchCheckout (applicationId) {
        return axios
            .get('/api/candidate/application/checkout', {
                params: { app_id: applicationId }
            })
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    savePaymentMode (data) {
        return axios
            .post('/api/candidate/application/payment', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    fetchCheckStub (id) {
        return axios
            .get('/api/candidate/application/paymentstub/' + id, {
                responseType: 'blob'
            })
            .then(function (response) {
                return response;
            });
    },
    documentComplete (data) {
        return axios
            .post('/api/candidate/application/documents_complete', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    documentVisa (data) {
        return axios
            .post('/api/candidate/application/documents_visa', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    updateCampusFrance (data) {
        return axios
            .post('/api/candidate/application/campus_france', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    documentSponsoring (data) {
        return axios
            .post('/api/candidate/application/documents_sponsoring', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    fundingConfirmation (data) {
        return axios
            .post('/api/candidate/application/funding_confirmation', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    fundingAdminValidation (data) {
        return axios
            .post('/api/candidate/application/funding_validated', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    removeFundingDocument (data) {
        return axios
            .post('/api/candidate/application/funding_document/delete', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    addressVisa (data) {
        return axios
            .post('/api/candidate/application/address_visa', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    validVisaDocument ({ candidateId, applicationId }) {
        return axios
            .post(`/api/candidate/${candidateId}/visa_doc_valid`, {
                application_id: applicationId,
            })
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    invalidVisaDocument ({ candidateId, applicationId, reason }) {
        return axios
            .post(`/api/candidate/${candidateId}/visa_doc_invalid`, {
                application_id: applicationId,
                visa_doc_validated_reason: reason,
            })
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    sendVisaRequestCertificate (data) {
        return axios
            .post('/api/candidate/application/visa_request_certificate', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    validResidencePermit ({ candidateId, applicationId }) {
        return axios
            .post(`/api/candidate/${candidateId}/residence_permit_valid`, {
                application_id: applicationId,
            })
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    invalidResidencePermit ({ candidateId, applicationId }) {
        return axios
            .post(`/api/candidate/${candidateId}/residence_permit_invalid`, {
                application_id: applicationId,
            })
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    resetVisaValidation ({ candidateId, applicationId }) {
        return axios
            .post(`/api/candidate/${candidateId}/visa_validation_reset`, {
                application_id: applicationId,
            })
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    validateSponsoringDocument (data) {
        return axios
            .post('/api/candidate/application/sponsoring_validated', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    invalidSponsoringDocument (data) {
        return axios
            .post('/api/candidate/application/sponsoring_invalid', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    saveProcessMode (data) {
        return axios
            .post('/api/candidate/application/process', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    removeDocument (data) {
        return axios
            .post('/api/candidate/application/document/delete', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    removeInterviewReport (data) {
        return axios
            .post('/api/interview_report/delete', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    removeAlternanceContract (data) {
        return axios
            .post('/api/alternance_contract/delete', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    checkScheduledInterview (data) {
        return axios
            .post('/api/candidate/application/interviews/check', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    setInterviewAppointment (application) {
        return axios
            .post('/api/candidate/application/interview/appointment', application)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    setInterviewAppointmentDate (application) {
        return axios
            .post('/api/candidate/application/interview/appointment_date', application)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    setInterviewAppointmentLink (application) {
        return axios
            .post('/api/candidate/application/interview/appointment_link', application)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    setInterviewComment (data) {
        return axios
            .post('/api/candidate/application/interview/comment', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    declareInterviewDone (data) {
        return axios
            .post('/api/candidate/application/interview/declare_done', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    attachInterviewReport (data) {
        return axios
            .post('/api/candidate/application/interview/attach_report', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    cancelInterviewDeclaration (data) {
        return axios
            .post('/api/candidate/application/interview/cancel_declaration', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    acceptApplication (application) {
        return axios
            .post('/api/candidate/application/accepted', application)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    refuseApplication (application) {
        return axios
            .post('/api/candidate/application/refused', application)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    cancelAcceptedApplication (application) {
        return axios
            .post('/api/candidate/application/canceled_accepted', application)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    cancelCompletedApplication (application) {
        return axios
            .post('/api/candidate/application/canceled_completed', application)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    cancelApplication (application) {
        return axios
            .post('/api/candidate/application/canceled', application)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    uncancelApplication (application) {
        return axios
            .post('/api/candidate/application/uncanceled', application)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    cancelAdmissionGraduated (applicationId, actions, reason) {
        return axios
            .post(`/api/admin/applications/${applicationId}/cancellation`, { actions, reason })
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    detachOrderCredit (orderId) {
        return axios
            .post(`/api/admin/orders/${orderId}/detach-credit`)
            .then(response => response)
            .catch(error => error.response);
    },
    fetchOrderAvailableCredits (orderId) {
        return axios
            .get(`/api/admin/orders/${orderId}/available-credits`)
            .then(response => response)
            .catch(error => error.response);
    },
    attachOrderCredit (orderId, creditId, amount) {
        return axios
            .post(`/api/admin/orders/${orderId}/attach-credit`, { credit_id: creditId, amount })
            .then(response => response)
            .catch(error => error.response);
    },
    suspendApplication (application) {
        return axios
            .post('/api/candidate/application/suspend', application)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    resumeApplication (application) {
        return axios
            .post('/api/candidate/application/resume', application)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    deleteApplication (applicationId) {
        return axios
            .post('/api/candidate/application/delete', { id: applicationId })
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    hasToPayFeesApplication (application) {
        return axios
            .post('/api/candidate/application/has_to_pay_fees', application)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    alternanceRequest (application) {
        return axios
            .post('/api/candidate/application/alternance_request', application)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    optionAlternance (application) {
        return axios
            .post('/api/candidate/application/option_alternance', application)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    cancelOptionAlternance (application) {
        return axios
            .post('/api/candidate/application/cancel_option_alternance', application)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    previewCandidatePaceCorrection (data) {
        return axios
            .post('/api/candidate/application/pace-correction/preview', data)
            .then(response => response)
            .catch(error => error.response);
    },
    candidatePaceCorrectionHistory (applicationId) {
        return axios
            .get(`/api/candidate/application/${applicationId}/pace-corrections`)
            .then(response => response)
            .catch(error => error.response);
    },
    correctCandidatePace (data) {
        return axios
            .post('/api/candidate/application/pace-correction', data)
            .then(response => response)
            .catch(error => error.response);
    },
    retryCandidatePaceSynchronization (data) {
        return axios
            .post('/api/candidate/application/pace-correction/retry', data)
            .then(response => response)
            .catch(error => error.response);
    },
    saveRegistration (data) {
        return axios
            .post('/api/candidate/application/register', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    saveRegistrationFunding (data) {
        return axios
            .post('/api/candidate/application/funding', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    saveApplicationStatus (data) {
        return axios
            .post('/api/candidate/application/status', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    saveApplicationReminder (data) {
        return axios
            .post('/api/candidate/application/reminder', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    deleteApplicationReminder (data) {
        return axios
            .post('/api/candidate/application/reminder/delete', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    saveApplicationSchedule (data) {
        return axios
            .post('/api/candidate/application/schedule', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    deleteApplicationSchedule (data) {
        return axios
            .post('/api/candidate/application/schedule/delete', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    updateSchedule (data) {
        return axios
            .post('/api/candidate/application/schedule/update', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    checkSchedule (data) {
        return axios
            .post('/api/candidate/application/schedule/check', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    checkAppointments (data) {
        return axios
            .post('/api/candidate/application/appointments/check', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    updateScheduleAppointment (data) {
        return axios
            .post('/api/candidate/application/schedule/appointment/update', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    markAppointmentsAsCompleted (data) {
        return axios
            .post('/api/candidate/application/schedule/appointment/complete', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    deleteSchedule (data) {
        return axios
            .post('/api/candidate/application/staff/delete', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    saveFinanceSchedule (data) {
        return axios
            .post('/api/candidate/finances/schedule', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    deleteFinanceSchedule (data) {
        return axios
            .post('/api/candidate/finances/schedule/delete', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    addTask (data) {
        return axios
            .post('/api/candidate/finances/task', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    deleteTask (data) {
        return axios
            .post('/api/candidate/finances/task/delete', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    doneTask (data) {
        return axios
            .post('/api/candidate/finances/task/done', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    saveFinanceProcess (data) {
        return axios
            .post('/api/candidate/application/finances/process', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    deleteFinanceProcess (data) {
        return axios
            .post('/api/candidate/application/finances/process/delete', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    sendMessage (message) {
        return axios
            .post('/api/candidate/application/message', message)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    transfertMessage (message) {
        return axios
            .post('/api/candidate/application/tranfert_message', message)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    transfertShopMessage (message) {
        return axios
            .post('/api/candidate/application/tranfert_shop_message', message)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    markAsRead (message) {
        return axios
            .post('/api/candidate/application/message/read', message)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    markShopMessageAsRead (message) {
        return axios
            .post('/api/candidate/shop/message/read', message)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    fetchComments (id) {
        return axios
            .get('/api/candidate/application/comments/' + id)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    fetchTimeline (candidateId, params = {}) {
        const query = new URLSearchParams();
        if (params.page) query.set('page', params.page);
        if (params.perPage) query.set('per_page', params.perPage);
        if (params.includePassive) query.set('include_passive_activity', '1');
        if (params.includeBulkMessages) query.set('include_bulk_messages', '1');
        if (params.view) query.set('view', params.view);
        if (params.since) query.set('since', params.since);
        const qs = query.toString();
        const url = '/api/candidate/' + candidateId + '/timeline' + (qs ? '?' + qs : '');
        return axios
            .get(url)
            .then(response => response)
            .catch(error => error.response);
    },
    composeTimelineAction (candidateId, payload) {
        return axios
            .post('/api/candidate/' + candidateId + '/timeline/actions', payload)
            .then(response => response)
            .catch(error => error.response);
    },
    markEventAttended (candidateId, candidateEventId) {
        return axios
            .post('/api/candidate/' + candidateId + '/timeline/events/' + candidateEventId + '/attended')
            .then(response => response)
            .catch(error => error.response);
    },
    deleteTimelineComment (candidateId, commentId) {
        return axios
            .post('/api/candidate/' + candidateId + '/timeline/comments/' + commentId + '/delete')
            .then(response => response)
            .catch(error => error.response);
    },
    closeTimelineSchedule (candidateId, scheduleId) {
        return axios
            .post('/api/candidate/' + candidateId + '/timeline/schedules/' + scheduleId + '/close')
            .then(response => response)
            .catch(error => error.response);
    },
    rescheduleTimelineSchedule (candidateId, scheduleId, payload) {
        return axios
            .post('/api/candidate/' + candidateId + '/timeline/schedules/' + scheduleId + '/reschedule', payload)
            .then(response => response)
            .catch(error => error.response);
    },
    sendComment (message) {
        return axios
            .post('/api/candidate/application/comment', message)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    updateComment (message) {
        return axios
            .post('/api/candidate/application/comment/edit', message)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    duplicateCandidate (message) {
        return axios
            .post('/api/candidate/duplicate_candidate', message)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    committeeCandidate (message) {
        return axios
            .post('/api/candidate/committee_candidate', message)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    deleteComment (id) {
        return axios
            .post('/api/candidate/application/comment/delete/' + id)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    fetchEvents (id) {
        return axios
            .get('/api/candidate/events/' + id)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    addEvent (event) {
        return axios
            .post('/api/candidate/event', event)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    addJpoEvent (event) {
        return axios
            .post('/api/candidate/event/register', event)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    delEvent (event) {
        return axios
            .post('/api/candidate/event/delete', event)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    receivedPayment (data) {
        return axios
            .post('/api/candidate/application/payment/received', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    receivedRegistration (data) {
        return axios
            .post('/api/candidate/application/registration/received', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    acceptPayment (data) {
        return axios
            .post('/api/candidate/application/registration/accepted', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    acceptRegistration (data) {
        return axios
            .post('/api/candidate/registration/accepted', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    acceptAlternanceRegistration (data) {
        return axios
            .post('/api/candidate/alternance/registration/accepted', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    cancelRegistration (data) {
        return axios
            .post('/api/candidate/registration/cancel', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    saveOfpCheck (data) {
        return axios
            .post('/api/candidate/registration/save_check', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    saveVisaTransfer (data) {
        return axios
            .post('/api/candidate/registration/save_visa_transfer', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    saveGuarantor (data) {
        return axios
            .post('/api/candidate/registration/save_guarantor', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },
    saveOrderPayments (data) {
        return axios
            .post('/api/order/save_payments', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },

    acceptOrderRegistration (data) {
        return axios
            .post('/api/order/registration/accepted', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },

    acceptOrderNoRegistration (data) {
        return axios
            .post('/api/order/noregistration/accepted', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },

    acceptOrderOfferRegistration (data) {
        return axios
            .post('/api/order/offerregistration/accepted', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },

    fetchDocuments (id) {
        return axios
            .get('/api/candidate/documents/' + id)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },

    bulkUnsendApplications (data) {
        return axios
            .post('/api/candidate/applications/bulk-unsend', data)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },

    // Candidate-level documents (new system)
    getCandidateDocuments (candidateId) {
        return axios
            .get('/api/candidate/' + candidateId + '/documents')
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },

    uploadCandidateDocument (candidateId, formData) {
        return axios
            .post('/api/candidate/' + candidateId + '/documents', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },

    removeCandidateDocument (documentId, source = 'candidate', applicationId = null) {
        return axios
            .post('/api/candidate/documents/delete', {
                id: documentId,
                source: source,
                application_id: applicationId
            })
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    },

    getCandidateDocumentCounts (candidateId) {
        return axios
            .get('/api/candidate/' + candidateId + '/documents/counts')
            .then(response => {
                return response;
            })
            .catch(error => {
                return error.response;
            });
    }
};
